import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import InspectionItem from '../InspectionItem'
import { renderFullDate } from '../../../../utils/time'
import { translation } from '../../../../utils/helpers'
import NotesModal from '../../../../shared/modals/NotesModal'
import { triggerPopup } from '../../../../actions/backdrop'
import UserInfo from '../../../../shared/components/UserInfo'

// Elements
import Button from '../../../../shared/elements/button'
import Inline from '../../../../shared/elements/inline'
import Grid from '../../../../shared/elements/grid'

class OtherComments extends Component {
  constructor (props) {
    super(props)
    this.state = {
      note: {
        modal: false,
        data: {}
      }
    }
    this.renderContent = this.renderContent.bind(this)
    this.showNoteModal = this.showNoteModal.bind(this)
  }

  componentDidMount () {
  }
  showNoteModal () {
    this.props.triggerPopup(!this.state.note.modal)
    this.setState({
      note: {
        ...this.state.note,
        data: {},
        modal: !this.state.note.modal
      }
    })
  }

  renderContent () {
    const openComment = () => {
      this.props.triggerPopup(true)
      this.setState({
        note: {
          data: {
            Note: '',
            NoteTypeID: 0,
            SourceID: 5,
            OrderID: this.props.order.Id,
            ApplyToInvoice: false
          },
          modal: true
        }
      })
    }
    // Comments
    let comments = !this.props.OrderNotes ? [] : this.props.OrderNotes.filter((v) => {
      return v.SourceID === 5
    })
    const renderComment = (item, key) => {
      let customerIcon = null
      if (!item.CreatedByCustommer && item.NoteTypeID === 1) {
        customerIcon = <div className='hint--top' aria-label={translation('2157')}><img src='/images/icons/Customer_16.png' /></div>
      }
      let invoiceIcon = <div className='hint--top' aria-label={translation('14835')}><img src='/images/svgs/invoice/Total_price.svg' /></div>
      // console.log(item)
      let note = (
        <Grid cols={[1, 'max-content']} align='start'>
          <div>
            <UserInfo user={item.UserInfo} />
            <span>{renderFullDate(item.NoteDate)}</span>
          </div>
          <Inline spacing={[0]}>
            {customerIcon}
            {item.ApplyToInvoice === true && invoiceIcon}
          </Inline>
        </Grid>
      )
      return (
        <div className='orderInspection-note'>
          {note}
          <div>{item.Note}</div>
        </div>
      )
    }
    // Return
    return (
      <div>
        {comments.map(renderComment)}
        <Button style='secondary' onClick={openComment} labelText={translation('149')} />
        {/* <img src='/images/svgs/inspection/add-white.svg' /> */}
      </div>
    )
  }
  render () {
    let title = { icon: '/images/svgs/inspection/comment.svg', text: '1894' }
    return (
      <div>
        <InspectionItem title={title} renderContent={this.renderContent} showCheckmark={false} />
        <NotesModal
          show={this.state.note.modal}
          onClose={this.showNoteModal}
          note={this.state.note.data}
          onSuccess={this.props.onNoteSuccess}
          standardNotes={this.props.standardNotes}
          onStandardNoteUpdate={this.props.onStandardNoteUpdate}
          order={this.props.order} />
      </div>
    )
  }
}

OtherComments.defaultProps = {
  isBodyshop: false
}

OtherComments.propTypes = {
  onNoteSuccess: PropTypes.func.isRequired,
  OrderNotes: PropTypes.array.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

OtherComments.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  triggerPopup
})(OtherComments)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/OtherComments/index.js